import { CSSVarHeaderHeight } from "components/global-styles/GlobalStyles";
// eslint-disable-next-line import/no-named-as-default
import styled from "styled-components";
import { BreakPoint } from "types/ui";

export const StyledMenu = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;
	justify-content: space-between;
	position: relative;
	width: 100%;

	@media screen and (min-width: ${BreakPoint.Medium}) {
		height: calc(100vh - ${CSSVarHeaderHeight});
		min-height: calc(100vh - ${CSSVarHeaderHeight});
		overflow-y: auto;
		width: 70%;
	}
`;
